<span class="content" (click)="contentClick()" (keyup.enter)="contentClick()">
  <ng-content></ng-content>
</span>

<button mat-icon-button class="close-button" aria-label="Close" (click)="dismiss()">
  <!-- <mat-icon svgIcon="close" aria-label="Dismiss notification"></mat-icon> -->
</button>
